module.exports = __webpack_public_path__ + "static/assets/67f61a6797faad9f0285517206b5ae27.png";